import mySubscriptions from './views/partials/dashboard-pages/mySubscriptions.js';
import mySubscriptionsPaymentModal from './views/partials/dashboard-pages/mySubscriptionsPaymentModal.js';
import personalData from './views/partials/dashboard-pages/personalData.js';

export default {
    init() {
        mySubscriptions();
        mySubscriptionsPaymentModal();
        personalData();
    },
    finalize () {},
};



// WEBPACK FOOTER //
// ./scripts/routes/templateDashboard.js